import { render } from "./S2PrizeModal.vue?vue&type=template&id=20d2f6be"
import script from "./S2PrizeModal.vue?vue&type=script&lang=js"
export * from "./S2PrizeModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__